module.exports = __webpack_public_path__ + "media/images/emblems/Dorf-blazon-2a2be5903534c18e821c5461a4bfec28.svg";